import React, { Component } from 'react';
import NoteItem from './note-item.js';
import _ from 'lodash';
import moment from 'moment';
import { db } from '../firebase';

export default class NoteList extends Component {


    constructor() {

        super();
        this.state = {
            search_kwd: '',
            active_color: null,
            note: ''
        }
        this.saveNote = this.saveNote.bind(this);
    }

    async componentDidMount() {

        this.loadNotes(this.props.symbol);
    }

    async componentWillReceiveProps(nextProps) {

        if (this.state.symbol != nextProps.symbol) {

            this.loadNotes(nextProps.symbol);
        }
    }
    async saveNote() {

        await db.saveNote(this.props.symbol, this.state.active_color, this.state.note);
        this.setState({
            note: ''
        });
        this.loadNotes(this.props.symbol);
    }

    async loadNotes(symbol) {

        let notes = await db.loadNotes(symbol);
        this.setState({
            all_notes: notes,
        });
    };


    render() {


        let colors = ["hsl(171, 100%, 41%)", "hsl(217, 71%, 53%)", "hsl(141, 71%, 48%)", "hsl(48, 100%, 67%)", "hsl(348, 100%, 61%)"];
        let active_color = this.state.active_color;
        return <div class="ss-container-stacked">

            <div class="card ss-fixed-row">
                <div class="card-content" style={{ padding: 10 }}>

                    <form>
                        <div class="field">
                            <div class="control">
                                <textarea class="textarea" placeholder="Enter your notes here" value={this.state.note} onChange={(e) => this.setState({ note: e.target.value })}></textarea>
                            </div>
                        </div>
                        <nav class="level">
                            <div class="level-left">
                                <div class="tabs is-toggle is-toggle-rounded">
                                    <ul>


                                        {colors.map(a => {

                                            return (
                                                <li onClick={() => { this.setState({ active_color: a }) }} style={{ backgroundColor: a }}>
                                                    <a>
                                                        <span class="icon">
                                                            <i className={"fa " + (a == active_color ? "fa-check-circle" : "fa-circle")} aria-hidden="true" style={{ color: "white" }}></i>
                                                        </span>
                                                    </a>
                                                </li>);
                                        })}

                                    </ul>

                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <a class="button is-success" onClick={this.saveNote}>
                                        <span class="icon is-small">
                                            <i class="fa fa-check"></i>
                                        </span>
                                        <span>Save</span>
                                    </a>
                                </div>
                            </div>
                        </nav>
                    </form>
                </div>
            </div>
            <div class="ss-fluid-row">
                {
                    this.state.all_notes && this.state.all_notes.length > 0 && (
                        <div>
                            {this.state.all_notes.map(note_item => {

                                return <NoteItem item={note_item} />
                            })}
                        </div>
                    )
                }
            </div>
        </div>
    };
}


// WEBPACK FOOTER //
// ./src/components/note-list.js